import dialogNames from 'constants/dialog-names';
import socialAccountProviderTypes from 'constants/social-account-provider-types';

function configurationToAuthenticatorURL(configuration) {

  const queryStringObject = {};

  for (let key in configuration) {

    if (key === 'provider' || key === 'oauth2_url') {
      continue;
    }

    let value = configuration[key];

    if (Array.isArray(value) === true) {
      value = value.join(' ');
    }

    queryStringObject[key] = value;

  }

  return configuration.oauth2_url + '?' + (new URLSearchParams(queryStringObject)).toString();

}

function buildFacebookOauthURL(configuration) {

  const client_id = configuration.client_id;
  const redirect_uri = configuration.integration_redirect_uri;
  const state = configuration.state;
  const scope = configuration.integration_scope.join(' ');
  const urlSearchParameters = new URLSearchParams({
    client_id,
    redirect_uri,
    state,
    scope
  });

  const oauthURL = `https://www.facebook.com/v15.0/dialog/oauth?${urlSearchParameters.toString()}`;

  return oauthURL;

}

function buildYoutubeOauthURL(configuration, state) {

  const client_id = configuration.client_id;
  const scope = configuration.scope.join(' ');
  const redirect_uri = configuration.redirect_uri;
  const response_type = 'code';
  const urlSearchParameters = new URLSearchParams({
    client_id,
    scope,
    redirect_uri,
    response_type,
    state,
    access_type: 'offline',
    prompt: 'consent'
  });

  const url = `https://accounts.google.com/o/oauth2/auth?${urlSearchParameters.toString()}`;

  return url;

}

function buildTiktokOauthURL(configuration, state) {

  const client_key = configuration.client_key;
  const scope = configuration.scopes.join(',');
  const redirect_uri = configuration.redirect_uri;
  const response_type = 'code';
  const urlSearchParameters = new URLSearchParams({
    client_key,
    scope,
    redirect_uri,
    response_type,
    state
  });

  const url = `https://www.tiktok.com/v2/auth/authorize/?${urlSearchParameters.toString()}`;

  return url;

}

function buildRedditOauthURL(configuration, state) {

  const urlSearchParameters = new URLSearchParams({
    client_id: configuration.client_id,
    response_type: 'code',
    state,
    redirect_uri: configuration.redirect_uri,
    duration: configuration.duration,
    scope: configuration.scope.join(' ')
  });

  return `${configuration.oauth2_url}?${urlSearchParameters.toString()}`;

}

export function buildStateParameter(dialogName = dialogNames.StartupSettings) {

  const state = JSON.stringify({
    href: window.location.href,
    'dialog-name': dialogName
  });

  return state;

}

export function buildGoogleOauthURL(configuration, state) {

  const client_id = configuration.client_id;
  const scope = configuration.scope.join(' ');
  const redirect_uri = configuration.redirect_uri;
  const response_type = 'code';
  const urlSearchParameters = new URLSearchParams({
    client_id,
    scope,
    redirect_uri,
    response_type,
    state: JSON.stringify(state),
    access_type: 'offline',
    prompt: 'consent'
  });

  const url = `https://accounts.google.com/o/oauth2/auth?${urlSearchParameters.toString()}`;

  return url;
}
// Instagram business accounts come with the Facebook page they are linked to.
export function findSignInProvider(provider) {

  if (provider === socialAccountProviderTypes.INSTAGRAM) {
    return socialAccountProviderTypes.FACEBOOK;
  }

  return provider;

}

// The redirect is the configured integration one, the same the server sends when it exchanges the code.
function buildLinkedInOauthURL(configuration, state) {

  return configurationToAuthenticatorURL({
    ...configuration,
    scope: configuration.integration_scope,
    redirect_uri: configuration.integration_redirect_uri,
    state
  });

}

// Facebook's sign-in, with the permissions to read and answer comments on the startup's posts.
export function withEngagementScope(configuration) {

  return Object.assign({}, configuration, {
    integration_scope: configuration.integration_scope.concat(configuration.engagement_scope)
  });

}

export function buildSignInURL(provider, configuration, state) {

  if (provider === socialAccountProviderTypes.FACEBOOK) {
    return buildFacebookOauthURL({ ...configuration, state });
  }

  if (provider === socialAccountProviderTypes.LINKED_IN) {
    return buildLinkedInOauthURL(configuration, state);
  }

  if (provider === socialAccountProviderTypes.TWITTER) {
    return `${configuration.oauth2_url}?oauth_token=${configuration.oauth_token}`;
  }

  if (provider === socialAccountProviderTypes.YOUTUBE) {
    return buildYoutubeOauthURL(configuration, state);
  }

  if (provider === socialAccountProviderTypes.TIKTOK) {
    return buildTiktokOauthURL(configuration, state);
  }

  return buildRedditOauthURL(configuration, state);

}
